/* eslint-disable camelcase */
import React, { memo } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import useUtms from 'hooks/useUtms'
import Link from 'next/link'
import sx from './styles'

const Buttons = ({ items, disclaimer }) => {
  const query = useUtms()

  const onClickHeroItem = (url_type, link) => {
    if (url_type === 'ancla') {
      document.getElementById(link).scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      })
    } else {
      return null
    }
  }

  const buttonContainer = (item, i) => {
    const safeLink = item?.link ? `${item?.link}${query}` : '#'

    const children = (
      <Button
        key={`button-${item?.name}`}
        color={item?.color}
        variant={item?.variant}
        target={item?.url_type === 'external_url' ? '_blank' : '_self'}
        rel="noreferrer"
        id={`home-banner-${i + 1}`}
        aria-label={item.name}
        title={item.title}
        fullWidth
        onClick={item.url_type !== 'internal_url'
          ? () => onClickHeroItem(item?.url_type, item?.link)
          : undefined}
        sx={sx.button}
        component={item?.type === 'ancla' ? 'button' : undefined} // Evita conflicto con `Link`
      >
        {item.name}
      </Button>
    )

    return item?.type === 'ancla' ? (
      children
    ) : (
      <Link
        href={safeLink}
        key={safeLink}
        passHref
      >
        {children}
      </Link>
    )
  }

  return (
    <Box sx={sx.buttons}>
      {items
        && items?.length > 0
        && items.map(
          (item, i) => (buttonContainer(item, i)),
        )}

      {disclaimer && (
        <Box sx={sx.disclaimerContainer}>
          <Typography
            variant="body2"
            align="center"
          >
            {disclaimer}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default memo(Buttons)
